import { render, staticRenderFns } from "./StockviewWarningToggle.vue?vue&type=template&id=77f82b28&"
import script from "./StockviewWarningToggle.vue?vue&type=script&lang=js&"
export * from "./StockviewWarningToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports